import * as $ from 'jquery';
import * as formValidation from '../modules/formValidation';
import TranslationsService from '../services/translationsService';

namespace PFF.controllers.caseLookup {

	let translationsService = TranslationsService.getInstance();
	let translationStrings = JSON.parse($("#translations").html());
	translationsService.init(translationStrings);

	let $alertSuccess = $('.js-alert-success');
	let $alertDanger = $('.js-alert-danger');
	let $alertDangerFields = $('.js-alert-danger-fields');

	let $email = $('#email');
	let $caseNumber = $('#case-number');

	let $submit = $('#submit');
	let $pleaseWait = $('#please-wait');

	let $loadIndicator = $('.js-load-indicator');

	let constraints = {
		email: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.EmailRequired')
			},
			email: {
				message: '^' + translationsService.translate('FormValidationErrors.EmailInvalid')
			}
		},
		'case-number': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CaseNumberRequired')
			}
		}
	};

	let validateField = function () {
		$(this).addClass('dirty');
		if (formValidation.validateWrapper({
			constraints: constraints,
			values: {
				email: $email.val(),
				'case-number': $caseNumber.val(),
			}
		})) {

		}
	};

	let inputEventListeners = function () {
		$email.on('blur change', validateField);
		$caseNumber.on('blur change', validateField);
	};

	let submitEventListener = function () {
		$submit.on('click', function (e) {
			e.preventDefault();

			$submit.addClass('hidden');
			$pleaseWait.removeClass('hidden');

			$('.js-alert').addClass('hidden');


			if (formValidation.validateWrapperSubmit({
					constraints: constraints,
					values: {
						email: $email.val(),
						'case-number': $caseNumber.val(),
					}
			})) {
				//form goes through
			} else {
				$alertDangerFields.removeClass('hidden');
				$("html, body").animate({ scrollTop: 0 }, 500);
				$submit.removeClass('hidden');
				$pleaseWait.addClass('hidden');
				return;
			}



			let data = {
				email: $email.val(),
				caseNumber: $caseNumber.val(),
			};

			$.get('/api/salesforce/get-case-id', data)
				.done(function (data) {
					$alertSuccess.removeClass('hidden');
					$loadIndicator.addClass('state-loading');
					location.assign(location.href + '?key=' + data);
				})
				.fail(function (response: any) {
					console.log(response);
					$alertDanger
						.removeClass('hidden')
						.find('.js-alert-text')
						.text(response.responseJSON.Message);
				})
				.always(function () {
					window.scrollTo(0, 0);
					$submit.removeClass('hidden');
					$pleaseWait.addClass('hidden');
				})
		});
	};

	export function init() {
		inputEventListeners();
		submitEventListener();
	}
}

PFF.controllers.caseLookup.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/caseLookup.ts